import { inject, Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { tap } from 'rxjs'

import { MessagingUIService } from '@app/modules/messaging/services/messaging-ui.service'

import * as fromThreads from '.'

@Injectable()
export class ThreadsEffects {
  private readonly actions$ = inject(Actions)
  private readonly messagingUIService = inject(MessagingUIService)

  readonly openMessageModal = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromThreads.Actions.openMessageModal),
        tap(({ profile }) => {
          this.messagingUIService.openMessageModal(profile)
        }),
      ),
    { dispatch: false },
  )
}
